import { useState, useEffect, useCallback } from 'react';
import { useRouteMatch } from 'react-router';
import { isEmpty } from 'lodash';
import {
  Invite as sdkInvite,
  User as sdkUser,
} from 'coolremote-sdk';
import { useStoreState } from '@models/RootStore';

export const useInviteInfo = () => {
  const match = useRouteMatch('/invite/:inviteToken');
  const inviteToken = match?.params?.inviteToken || '';
  const types = useStoreState((s) => s.types);

  const [inviteInfo, setInviteInfo] = useState(null);
  const [userMode, setUserMode] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expired, setIsExpired] = useState(false);

  const goToHome = useCallback(() => {
    window.location.href = "/";
  }, []);

  useEffect(() => {
    const fetchInviteInfo = async () => {
      if (!inviteToken || !types || isEmpty(types)) {
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const resp = await sdkInvite.getInviteInfo(inviteToken);
        setInviteInfo(resp);

        // Check if username is available to determine user mode
        const usernameCheck = await sdkUser.isUsernameAvailable(resp.email);
        setUserMode(!usernameCheck?.available ? "existing" : "new");
      } catch (error) {
        setIsExpired(true);
        const errorMessage = error?.message || 'Failed to load invitation details';
        setError(errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInviteInfo();
  }, [inviteToken, types, goToHome]);

  return {
    inviteToken,
    inviteInfo,
    userMode,
    isLoading,
    error,
    expired
  };
};
